var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 154.538,
    height: 43.312,
    viewBox: "0 0 154.538 43.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#f);}.d{fill:url(#g);}.e{fill:url(#h);}.f{fill:url(#i);}.g{fill:url(#j);}.h{fill:url(#k);}.i{opacity:0.77;}.j{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: -5.253,
    x2: 0.5,
    y2: 1.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: -5.451,
    x2: 0.5,
    y2: 1.043,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: -5.359,
    x2: 0.5,
    y2: 1.025,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.5,
    y1: -5.451,
    x2: 0.5,
    y2: 1.043,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.031,
    y1: 0.5,
    x2: 0.969,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.031,
    y1: 0.5,
    x2: 0.969,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#00f6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#00deff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#00b6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.031,
    y1: 0.5,
    x2: 0.969,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00d4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.252,
    y1: 0.068,
    x2: 0.751,
    y2: 0.932,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.116 0.577)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M424.533,127.476l1.085-2.406a8.121,8.121,0,0,0,4.556,1.44c1.894,0,2.663-.631,2.663-1.479,0-2.584-8.028-.809-8.028-5.937,0-2.347,1.893-4.3,5.819-4.3a9.261,9.261,0,0,1,4.793,1.223l-.986,2.426a7.8,7.8,0,0,0-3.826-1.085c-1.893,0-2.623.71-2.623,1.578,0,2.544,8.028.789,8.028,5.858,0,2.308-1.913,4.28-5.858,4.28A9.841,9.841,0,0,1,424.533,127.476Z",
    transform: "translate(-372.016 -100.834)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M542.133,127.916v2.564h-10.69V116.673h10.434v2.564h-7.258v3h6.41v2.485h-6.41v3.2Z",
    transform: "translate(-465.455 -102.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M647.571,116.673V130.48h-3.2v-5.661H638.1v5.661h-3.2V116.673h3.2v5.444h6.272v-5.444Z",
    transform: "translate(-555.883 -102.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M756.324,127.521h-6.41l-1.223,2.959h-3.274l6.154-13.807h3.156L760.9,130.48h-3.353Zm-1.006-2.426-2.189-5.286L750.94,125.1Z",
    transform: "translate(-652.467 -102.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M890.819,116.673V130.48h-3.2v-5.661h-6.272v5.661h-3.2V116.673h3.2v5.444h6.272v-5.444Z",
    transform: "translate(-768.481 -102.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1002.13,124.4v-7.732h3.2v7.613c0,2.623,1.144,3.708,3.077,3.708,1.953,0,3.077-1.085,3.077-3.708v-7.613h3.156V124.4c0,4.063-2.327,6.312-6.252,6.312S1002.13,128.468,1002.13,124.4Z",
    transform: "translate(-876.833 -102.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1137.509,126.712c0,2.387-1.894,3.767-5.523,3.767h-7.14V116.673h6.746c3.451,0,5.227,1.44,5.227,3.59a3.319,3.319,0,0,1-1.834,3.037A3.409,3.409,0,0,1,1137.509,126.712Zm-9.487-7.633v3.254h3.176c1.558,0,2.406-.552,2.406-1.637s-.848-1.617-2.406-1.617Zm6.272,7.3c0-1.164-.888-1.716-2.544-1.716h-3.728v3.412h3.728c1.656,0,2.545-.513,2.545-1.7Z",
    transform: "translate(-984.087 -102.476)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 23.473,
    height: 8.871,
    rx: 4.436,
    transform: "translate(29.263 30.172) rotate(-154.242)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 23.473,
    height: 8.871,
    rx: 4.436,
    transform: "translate(8.083 15.811) rotate(-25.758)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 23.473,
    height: 8.871,
    rx: 4.436,
    transform: "translate(8.161 28.562) rotate(-25.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M40.5,12.678a21.653,21.653,0,1,0,1.7,8.4,21.653,21.653,0,0,0-1.7-8.4ZM20.609,41.194a20.107,20.107,0,1,1,7.829-1.58A20.119,20.119,0,0,1,20.609,41.194Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(19.044 24.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.63,
    height: 6.072,
    transform: "translate(0 0.27) rotate(-25.347)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(18.97 11.822)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.63,
    height: 6.072,
    transform: "translate(0 0.27) rotate(-25.347)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.62b0522bb150eca0e100700d50c1d86e.svg";
export { ForwardRef as ReactComponent };